import { advanceSimClock } from './timing'
import type { MotionPrefs } from './types'

/** Lightweight simulation-time clock for world presentation. */
export class PresentationClock {
  private simTime = 0

  get time(): number {
    return this.simTime
  }

  reset(): void {
    this.simTime = 0
  }

  tick(realDeltaSec: number, prefs: MotionPrefs): number {
    this.simTime = advanceSimClock(this.simTime, realDeltaSec, prefs)
    return this.simTime
  }
}
